// src/pages/WhatToExpectPage.jsx

import React from "react";
import { useNavigate } from "react-router-dom";

const hero = "/assets/resources/hero.jpg";
const cameras = "/assets/resources/cameras.jpg";
const hydrate = "/assets/resources/hydrate.jpg";
const meals = "/assets/resources/meals.jpg";
const uniforms = "/assets/resources/uniforms.jpg";
const lockers = "/assets/resources/lockers.jpg";
const arrival = "/assets/resources/arrival.jpg";
const media = "/assets/resources/media.jpg";
const proactive = "/assets/resources/proactive.jpg";
const welcome = "/assets/resources/welcome.jpg";
const weather = "/assets/resources/weather.jpg";
const weapons = "/assets/resources/weapons.jpg";

function Section({ title, text, image, reverse = false }) {
  return (
    <section style={{ padding: "32px 0" }}>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: window.innerWidth >= 900 ? "1fr 1fr" : "1fr",
          gap: "24px",
          alignItems: "center",
        }}
      >
        <div style={{ order: reverse && window.innerWidth >= 900 ? 2 : 1 }}>
          <div
            style={{
              width: "100%",
              height: window.innerWidth >= 900 ? "420px" : "260px",
              overflow: "hidden",
              borderRadius: "16px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
              background: "#f3f4f6",
            }}
          >
            <img
              src={image}
              alt={title}
              style={{
                width: "100%",
                height: "100%",
                objectFit: image === weather ? "contain" : "cover",
                objectPosition: "center",
                display: "block",
                backgroundColor: "#ffffff",
              }}
            />
          </div>
        </div>

        <div style={{ order: reverse && window.innerWidth >= 900 ? 1 : 2 }}>
          <h2
            style={{
              fontSize: "36px",
              fontWeight: 300,
              color: "#7c3a8f",
              marginBottom: "16px",
            }}
          >
            {title}
          </h2>

          <div style={{ color: "#1f2937", fontSize: "18px", lineHeight: 1.7 }}>
            {text.map((t, i) => (
              <p key={i} style={{ marginBottom: "14px" }}>
                {t}
              </p>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default function WhatToExpectPage() {
  const navigate = useNavigate();

  return (
    <div style={{ maxWidth: "1200px", margin: "0 auto", padding: "24px 16px 48px" }}>
      <button
        onClick={() => navigate("/dashboard?quicklinks=true")}
        style={{
          marginBottom: 20,
          padding: "10px 16px",
          backgroundColor: "#6b4fa3",
          color: "white",
          border: "none",
          borderRadius: 6,
          cursor: "pointer",
          fontWeight: 500,
        }}
      >
        ← Return to Quick Links
      </button>

      <div style={{ marginBottom: "40px" }}>
        <div
          style={{
            width: "100%",
            height: window.innerWidth >= 900 ? "320px" : "220px",
            overflow: "hidden",
            borderRadius: "24px",
            boxShadow: "0 6px 18px rgba(0,0,0,0.16)",
          }}
        >
          <img
            src={hero}
            alt="Travelers Championship"
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
          />
        </div>

        <div style={{ marginTop: "18px" }}>
          <h1 style={{ fontSize: "40px", fontWeight: 700, margin: 0 }}>
            What to Expect
          </h1>
        </div>
      </div>

      <Section title="Welcome" image={welcome} reverse text={["Welcome to the Saint Francis Hospital Travelers Championship Medical Team. The medical care we provide at this tournament is consistently cited by the PGA as being the best on the tour.  One of the reasons for this acknowledgment is that we are visible yet quiet.  We provide concierge medicine to spectators, vendors, volunteers, PGA Tour players and their families. We work very hard to get to 'YES' no matter how small the task is. Whether its just a band aide or a critical emergency, we treat EVERYONE as a VIP.",

        "We hope you enjoy your time with us on the course and ask you to keep in mind that we are all here first to perform an important job. Cooperation with station/sector assignments, our supervisors, and our dispatch center is essential to a smooth operation.",
        ]} />

      <Section title="Getting Here" image={arrival} text={["The address for the course is 1 Golf Club Road, Cromwell, CT 06416. however, when you arrive you will use the Travelers Championship Road entrance just north of Golf Club Road. Please enter the Gold Lot from the Main Street entrance. You will bear left at the first intersection and follow Travelers Championship Road around the back of the practice facility and into the lot. Security will likely meet you at the entrance and direct you where to park. Please follow their directions and don't park in unauthorized areas.",
        "Once you park, walk toward the main gate. Just to the left of the main security check point is the vendor entrance. Enter here. Once inside, we are located just to the right."
      ]} />

      <Section title="Equipment & Gear" image={weapons} reverse text={["We will provide everything you need when you get here. If you prefer to use your own stethoscope you can, but knives and scissors are not needed and likely wont get through security.  Please leave these items at home."]} />

      <Section title="Lockers" image={lockers} text={["Lockers are available for use if you'd like to lock up personal belongings during your shift. Please bring your own lock if you plan to use a locker."]} />

      <Section title="Meals" image={meals} reverse text={["Meals are provided during your shift. We will have a light grab and go breakfast in the morning as well as food vouchers for use at the various concessions around the course. If you choose to bring your own meals please bring your own cooler."]} />

      <Section title="Uniforms" image={uniforms} text={["We will provide you with a shirt and hat when you get here. Please wear navy blue or khaki shorts or pants (NO JEANS), and comfortable sneakers. Rain gear will be provided when needed. Shirts must be tucked in with sleeves rolled down.  If you're working on your tan, you're in the wrong place! Farmers tans are way cooler anyway!"]} />

      <Section title="Stay Hydrated" image={hydrate} reverse text={["You will be outside in the heat and sun all day. Please hydrate prior to, and during your shift. Water and Powerade will be provided."]} />

      <Section title="Cameras are Everywhere" image={cameras} text={["This is a nationally televised event and there are cameras everywhere. If you are not in a bathroom, it's safe to assume that you're on camera. Please always conduct yourself in a professional manner."]} />

      <Section title="Be Proactive" image={proactive} reverse text={["Please be proactive. Interact with the public, offer sunscreen, offer to help when appropriate, look for and report hazards to 'BIRDIE'. Do your part to make this the best experience for the patrons, golfers, caddies and volunteers. We are known throughout the PGA tour as the best in the business, please help us keep it that way."]} />

      <Section title="Media" image={media} text={["Please do not speak to the media without authorization from a member of the command staff. All media interactions must go through the marketing department."]} />

      <Section
        title="Emergency Situations"
        image={weather}
        reverse
        text={[
          "The PGA TOUR utilizes an audio and visual system on scoreboards throughout the grounds.",
          "Weather events may include air horn blasts and evacuation messaging.",
          "You will receive instructions from your supervisor if an emergency occurs.",
        ]}
      />
    </div>
  );
}